export const getEnv = (val: string | undefined, name: string): string => {
  /**
   * This is a simple utility function to retrieve environment variables (without cloudflare support).
   * -
   * We can't simply use getEnv("NEXT_PUBLIC_PANICH_API") because
   * Next.js env to be defined as process.env.NEXT_PUBLIC_PANICH_API
   * so that it can be in-lined at build time.
   * https://nextjs.org/docs/app/guides/environment-variables#bundling-environment-variables-for-the-browser
   * -
   * That's why api is quite repetitive.
   * -
   * Example usage:
   * getEnv(process.env.NEXT_PUBLIC_PANICH_API, "NEXT_PUBLIC_PANICH_API");
   * -
   */

  if (!val) {
    throw new Error(`Environment variable "${name}" is not set`);
  }

  return val;
};
